import { Component } from '@angular/core';
import { AuthNewService } from '../../../service/auth-new.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-totp-setup',
  templateUrl: './totp-setup.component.html',
  styleUrls: ['./totp-setup.component.scss'],
  standalone: false
})
export class TotpSetupComponent {
  step: 'loading' | 'scan' | 'verify' | 'done' = 'loading';
  qrUri = '';
  code = '';
  error = '';

  constructor(private authService: AuthNewService, private router: Router) {}

  ngOnInit(): void {
    this.loadQR();
  }

  async loadQR() {
    try {
      this.qrUri = await this.authService.createURI();
      this.step = 'scan';
    } catch (err: any) {
      this.error = err?.message || 'Failed to generate QR code.';
      this.step = 'scan';
    }
  }

  async verify() {
    this.error = '';
    try {
      await this.authService.verifyTOTP(this.code);
      await this.authService.enableTOTPMFA();
      this.step = 'done';
    } catch (err: any) {
      this.error = err?.message || 'Invalid code. Please try again.';
    }
  }

  goToProfile() {
    this.router.navigate(['/default-layout/user-info']);
  }
}